import Cookies from "js-cookie";

export const getUserInfo = () => {
  const loggedInUserCookie = Cookies.get("user");
  const userInfo = loggedInUserCookie ? JSON.parse(loggedInUserCookie) : null;
  if (!userInfo) {
    return { userId: "NO_ID", userName: "NO_USER_NAME", nameUser: "NO_NAME" };
  }
  const userId = String(userInfo.id);
  const nameUser = userInfo.userAttributes.name;
  const userName = userInfo.username;
  return { userId, userName, nameUser };
};
